'use client';

import Script from 'next/script';
import { getCookieYesScriptUrl } from '@/lib/consent/cookieyes-adapter';

export default function CookieYesScript() {
    const scriptUrl = getCookieYesScriptUrl();

    if (!scriptUrl) {
        return null;
    }

    return <Script id="cookieyes" src={scriptUrl} strategy="afterInteractive" />;
}